import React from 'react';
import ReactSelect from 'react-select';
import newId from "../../utils/newid";
import style from './style.scss'
import Label from './Label';

const Select = (props) => {


    const {label,options,name,value,placeholder,onChange,isReadOnly,className} = props;

    // return (<div className="form-group">
    return (<div className={className}>
        <label htmlFor={name}> {label} </label>
        <ReactSelect
            id={name}
            name={name}
            classNamePrefix="acd_form"
            value={value}
            placeholder={placeholder}
            options={options}
            onChange={onChange}

        />

    </div>)
}

export default Select;

export const RenderSelect = (props) =>{
        const {item, field,isReadOnly} = props;
        const id = newId();
        return (
            <div className={style.typeSelect}>
                {
                    (typeof item.label !== 'undefined') &&
                    <Label
                        id={id}
                        parentClass
                        label={item.label}
                    />}
                    
                <ReactSelect
                    id={id}
                    value={(typeof field !== "undefined") && item.options.filter(e=>e.value===field[item.item])}
                    classNamePrefix="acd_form"
                    options={item.options}
                    onChange={(t) => {
                        return props.handleChange(t.value)
                    }}
                    isDisabled={isReadOnly}
                />

            </div>
        )

}
